import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { registerServiceWorker, requestPersistentStorage } from "@/hooks/useOfflineSync";
import { initDB } from "@/lib/offlineDB";

// Initialize offline capabilities
async function initOffline() {
  try {
    await initDB();
    await registerServiceWorker();
    await requestPersistentStorage();
    console.log('[App] Offline capabilities initialized');
  } catch (err) {
    console.warn('[App] Failed to initialize offline capabilities:', err);
  }
}

initOffline();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
